// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","MenuItem":"bgl_a bhr_vt bhr_ea bhr_a","MenuItem__Btn":"bgl_b bhr_z","MenuItem__subtitle":"bgl_c"};